// src/pages/payments/PaymentCancel.tsx
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { companyRoute } from "../utils/routeHelpers";
import { A } from "../styles/appleClasses";

export default function PaymentCancel() {
  const { company_id } = useParams<{ company_id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (company_id) {
      navigate(companyRoute(company_id, "/sales"), { replace: true });
    } else {
      navigate(-1);
    }
  }, [company_id, navigate]);

  return (
    <div
      className={`min-h-[220px] bg-gray-50 ${A.body} flex flex-col items-center justify-center px-4 py-10`}
    >
      <div className={`${A.card} px-6 py-5 w-full max-w-md text-center`}>
        <div className={A.title}>Payment canceled</div>
        <div className={`mt-2 ${A.label}`}>Returning to Sales…</div>
      </div>
    </div>
  );
}
